export class EnquiryPackBomRequest{
    id: number;
    itemCategoryId: number
    itemSubCategoryId: number
    itemId: number
    quantity: number
    enquiryId: number
    constructor(
        id: number,
        itemCategoryId: number,
        itemSubCategoryId: number,
        itemId: number,
        quantity: number,
        enquiryId: number
    ){
        this.id = id
        this.itemCategoryId = itemCategoryId
        this.itemSubCategoryId = itemSubCategoryId
        this.itemId = itemId
        this.quantity = quantity
        this.enquiryId = enquiryId
    }
}